import { Button, Typography } from "@suraasa/placebo-ui"
import clsx from "clsx"
import { ArrowLeft, ArrowRight } from "iconoir-react"

import { useUserLeadContext } from "./Context"

type Props = {
  currentStep: number
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>
  totalSteps: number
}

const BottomBar = ({ currentStep, setCurrentStep, totalSteps }: Props) => {
  const { refreshData } = useUserLeadContext()
  const isLastStep = currentStep === totalSteps
  const isFirstStep = currentStep === 0

  const handleNext = () => {
    if (isLastStep) return
    setCurrentStep(p => p + 1)
    refreshData()
  }

  const handlePrev = () => {
    if (isFirstStep) return
    setCurrentStep(p => p - 1)
    refreshData()
  }

  return (
    <div
      className={clsx(
        "my-2 flex flex-wrap items-center justify-between  rounded-2xl border border-onSurface-200 bg-white px-3 py-2 md:gap-0",
        isLastStep ? "flex-col gap-2 md:flex-row" : "gap-3"
      )}
    >
      <Typography variant="largeBody">
        Ready to move to the next step?
      </Typography>
      <div className="flex gap-1">
        {currentStep !== 1 && (
          <Button
            startAdornment={<ArrowLeft />}
            onClick={handlePrev}
            variant="outlined"
            size="sm"
          >
            Previous
          </Button>
        )}
        <Button
          disabled={isLastStep}
          endAdornment={<ArrowRight />}
          onClick={handleNext}
          size="sm"
        >
          Next
        </Button>
      </div>
    </div>
  )
}

export default BottomBar
